// extracted by mini-css-extract-plugin
export default {"container":"zG","promoapplied":"AG","tobeapplied":"BG","hr":"CG","teal":"EG","promoappliedcontainer":"FG","error":"GG","input":"HG","errorInput":"IG","promo_x":"JG","promo_info":"KG","promoxcontainer":"LG"};
    if(module.hot) {
      // 1714442369975
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  